import {
  handleDonorIdChange,
  handleEmiratesIdChange } from
"./handers/FormHandlers";
import {
  getDonorDetailsByEmiratesId,
  getDonorDetailsByDonorId,
  getCardProfileDataLinkingAccount } from
"../../../services/epic/bloodDonation";
import AlertDependent from "../../../common/AlertDependent";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import OtpVerification from "./OtpVerification";
import { getLiferayUserScreenName } from "../../../utils/themeDisplay";
import { Loader } from "../../../common/Loader";
import { convert } from "../../../utils/util";

export const LinkDonorAccount = ({
  linkSuccessful,
  setLinkSuccessful,
  email,
  requestStep,
  setRequestStep,
  translationMap
}) => {
  const [donorId, setDonorId] = useState("");
  const [donorYear, setDonorYear] = useState("");
  const [donorYearError, setDonorYearError] = useState("");
  const [mrnYearError] = useState("");
  const [mrnError, setMrnError] = useState("");
  const [errorMessage, setErrorMessage] = useState(false);

  const [emiratesId, setEmiratesId] = useState("");
  const [emiratesYear, setEmiratesYear] = useState("");
  const [emiratesIdError, setEmiratesIdError] = useState("");
  const [emiratesYearError, setEmiratesYearError] = useState("");

  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  const [otpVerification, setOtpVerification] = useState(false);
  const [profile, setProfile] = useState(null);
  const [userName, setUserName] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [id, setId] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    getLiferayUserScreenName((screenName) => {
      setUserName(screenName);
    });
  }, []);

  useEffect(() => {
    const disableButton = !(donorId || donorYear || emiratesId || emiratesYear);
    setIsButtonDisabled(disableButton);
  }, [donorId, emiratesId, donorYear, emiratesYear]);

  const validateInput = async () => {
    setErrorMessage(false);
    try {
      if (donorId) {
        if (!donorYear)
        {
          setDonorYearError(translationMap?.dateOfBirthRequired || "DOB is Required");
          return;
        }
        const paddedDonorId = donorId.padStart(6, "0");
        setDonorId(paddedDonorId);
        try {
          const donorDetails = await getDonorDetailsByDonorId(paddedDonorId, userName);
          if (donorDetails?.data?.items[0] && donorDetails?.data?.items[0].isVisible === 1) {
            window.parent.scrollTo(0, 0);
            setErrorMessage(
              translationMap?.idAlreadyLinked
            );
            return;
          }
        } catch (error) {
          setErrorMessage(
            translationMap?.errorOccuredWhileFetchingProfile
          );
          return;
          //  console.error("Error while fetching donor details:", error);
        }
        const info = await getCardProfileDataLinkingAccount(paddedDonorId, emiratesId, convert(donorYear), convert(emiratesYear), userName);
        setIsLoading(false);
        if (!info)
        {
          // setIsLoading(false);
          setErrorMessage(translationMap?.profieNotFound);
          return;
        } else
        if (info?.data?.result === "DOB doesnot match")
        {
          // setIsLoading(false);
          setErrorMessage(translationMap?.validDateOFBirth);
          return;
        } else
        if (info?.data?.message === "otpBlocked")
        {
          // setIsLoading(false);
          setErrorMessage(true);
          return;
        } else
        {
          const idInfo = info?.data?.id;
          setId(idInfo);
          setProfile(info?.data);
          // setIsLoading(false);
          setOtpVerification(true);
        }
      } else {
        if (!emiratesYear)
        {
          setEmiratesYearError(translationMap?.dateOfBirthRequired || "Date of Birth os required");
          return;
        }
        try {
          const donorDetails = await getDonorDetailsByEmiratesId(emiratesId, userName);
          if (donorDetails?.data?.items[0] && donorDetails?.data?.items[0].isVisible === 1) {
            window.parent.scrollTo(0, 0);
            setErrorMessage(
              translationMap?.idAlreadyLinked
            );
            return;
          }
        } catch (error) {
          setErrorMessage(
            translationMap?.errorOccuredWhileFetchingProfile
          );
          return;
          // console.error("Error while fetching donor details:", error);
        }

        const info = await getCardProfileDataLinkingAccount(donorId, emiratesId, convert(donorYear), convert(emiratesYear), userName);
        setIsLoading(false);
        if (!info)
        {
          setErrorMessage(translationMap?.profieNotFound);
          return;
        } else
        if (info?.data?.result === "DOB doesnot match")
        {
          //setIsLoading(false);
          setErrorMessage(translationMap?.validDateOFBirth);
          return;
        } else
        if (info?.data?.message === "otpBlocked")
        {
          // setIsLoading(false);
          setErrorMessage(true);
          return;
        } else
        {
          const idInfo = info?.data?.id;
          setId(idInfo);
          // setIsLoading(false);
          setProfile(info?.data);
          setOtpVerification(true);
        }
      }
    } catch (error) {
      setErrorMessage(
        translationMap?.errorOccuredWhileFetchingProfile
      );
      return;
      //console.log("error in validation", error?.message);
    }
  };

  if (isLoading)
  {
    return (
      <Loader />);

  }

  return (
    <>
            <section
        className="w-100 clearfix BloodDonationMainSection"
        id="CoverPlanActive">
        
                <div className="container customContainer">
                    <div className="Title_Inner_Box">
                        <h6 className="MainTitleOne">{translationMap?.linkDonorAccount}</h6>
                    </div>
                    <div className="cover_inner_wrapper">
                        <div className="cover_main_box1">
                            {errorMessage &&
              <AlertDependent
                setError={setErrorMessage}
                alert_text={errorMessage} />

              }
                            <div className="donation_form_title_box">
                                <p className="Gray_Title">
                                    {translationMap?.linkDonorAccountUsingId}
                                </p>
                            </div>
                            <div className="dependent_form_box">
                                <form onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    document.getElementById("linkAccountButton")?.click();
                  }
                }}>
                                    <div className="form_inner_box">
                                        <div className="inner_input_box">
                                            <div className="input_box">
                                                <label>{translationMap?.donorId}</label>
                                                <div className="input_wrap">
                                                    <input
                            type="text"
                            name="number"
                            inputmode="numeric"
                            placeholder={translationMap?.typeYourDonorId}
                            value={donorId}
                            onChange={(e) =>
                            handleDonorIdChange(
                              e,
                              setDonorId,
                              setEmiratesId,
                              setEmiratesYear,
                              setMrnError,
                              setEmiratesIdError,
                              translationMap
                            )
                            }
                            //disabled={emiratesId}
                            style={{
                              borderColor: mrnError ?
                              "#FF8F8A" :
                              "rgb(128 153 178)"
                            }} />
                          
                                                    {mrnError &&
                          <span id="text" style={{ color: "#FF8F8A" }}>
                              {mrnError}
                            </span>
                          }
                                                </div>
                                            </div>
                                        </div>
                                        <div className="inner_input_box">
                                            <div className="input_box">
                                                <label>{translationMap?.dob}</label>
                                                <div className="input_wrap">
                                                    <DatePicker
                            selected={donorYear}
                            placeholderText="DD/MM/YYYY"
                            onChange={(date) => {
                              setDonorYear(date);
                            }}
                            maxDate={new Date()}
                            className="date_input"
                            id="displayDateInput"
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            dateFormat="dd/MM/yyyy"
                            //disabled={!donorId}
                            onKeyDown={(e) => {
                              e.preventDefault();
                            }}
                            style={{
                              borderColor: mrnYearError ?
                              "#FF8F8A" :
                              "rgb(128 153 178)"
                            }} />
                          
                                                    {donorYearError &&
                          <span id="text" style={{ color: "#FF8F8A" }}>
                              {donorYearError}
                            </span>
                          }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form_inner_box">
                                        <div className="form_title">
                                            <h6 className="Gray_Title">
                                                {translationMap?.useEmiratesId}
                                            </h6>
                                        </div>
                                    </div>
                                    <div className="form_inner_box">
                                        <div className="inner_input_box">
                                            <div className="input_box">
                                                <label>{translationMap?.emiratesId}</label>
                                                <div className="input_wrap">
                                                    <input
                            type="text"
                            name="number"
                            inputmode="numeric"
                            placeholder={translationMap?.typeYourEmiratedId}
                            value={emiratesId}
                            onChange={(e) =>
                            handleEmiratesIdChange(
                              e,
                              setEmiratesId,
                              setDonorId,
                              setDonorYear,
                              setEmiratesIdError,
                              setMrnError,
                              translationMap
                            )
                            }
                            //disabled={donorId}
                            style={{
                              borderColor: emiratesIdError ?
                              "#FF8F8A" :
                              "rgb(128 153 178)"
                            }} />
                          
                                                    {emiratesIdError &&
                          <span id="text" style={{ color: "#FF8F8A" }}>
                              {emiratesIdError}
                            </span>
                          }
                                                </div>
                                            </div>
                                        </div>
                                        <div className="inner_input_box">
                                            <div className="input_box">
                                                <label>{translationMap?.dob}</label>
                                                <div className="input_wrap">
                                                    <DatePicker
                            selected={emiratesYear}
                            placeholderText="DD/MM/YYYY"
                            onChange={(date) => {
                              setEmiratesYear(date);
                            }}
                            maxDate={new Date()}
                            className="date_input"
                            id="displayDateInput"
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            dateFormat="dd/MM/yyyy"
                            // disabled={!emiratesId}
                            onKeyDown={(e) => {
                              e.preventDefault();
                            }}
                            style={{
                              borderColor: mrnYearError ?
                              "#FF8F8A" :
                              "rgb(128 153 178)"
                            }} />
                          
                                                    {emiratesYearError &&
                          <span id="text" style={{ color: "#FF8F8A" }}>
                              {emiratesYearError}
                            </span>
                          }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form_btn_box">
                    <span>
                      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                      <a
                        id="linkAccountButton"
                        className={`${
                        isButtonDisabled ?
                        "disabled_btn_link" :
                        "blue_btn_link"}`
                        }
                        onClick={validateInput}>
                        
                        {translationMap?.linkAccount}
                      </a>
                    </span>
                                        <span>
                      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                      <a
                        className="bluetrans_btn_link"
                        onClick={() => navigate("/")}>
                        
                        {translationMap?.backToDammi}
                      </a>
                    </span>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {otpVerification &&
      <OtpVerification
        profile={profile}
        setOtpVerification={setOtpVerification}
        linkSuccessful={linkSuccessful}
        setLinkSuccessful={setLinkSuccessful}
        email={email}
        requestStep={requestStep}
        setRequestStep={setRequestStep}
        id={id}
        donorId={donorId}
        emiratesId={emiratesId}
        donorYear={donorYear}
        emiratesYear={emiratesYear}
        userName={userName}
        translationMap={translationMap} />

      }
        </>);

};